module.exports = __webpack_public_path__ + "static/media/kircholm.3df142d5.jpg";